import React from 'react';

const LoadingPage = ({ message = 'Loading...' }) => {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-charcoal-950 text-white">
        <div className="text-center flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-charcoal-800 border-t-blue-500 mb-6"></div>
            <p className="text-lg text-blue-500 font-medium animate-pulse">{message}</p>
        </div>
    </div>
  );
};

export default LoadingPage;
